import { ColorModeBgPropKeys } from 'styles/colors';
import { cssVar } from 'styles/helper';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledMain = styled.main`
  color: ${cssVar('text-primary')};
  font-size: 16px;
  overflow-x: clip;
`;

export interface GlobalBodyStylesProps {
  backgroundColor?: ColorModeBgPropKeys;
}

export const GlobalBodyStyles = createGlobalStyle<GlobalBodyStylesProps>`
  body {
    font-family: ${cssVar('font-family-body')};
    margin: 0;
    overflow-x: hidden;
    text-rendering: optimizeSpeed;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    width: 100vw;
    ${({ backgroundColor }) => (!backgroundColor ? '' : `background-color: ${cssVar(backgroundColor)};`)}
  }
`;
